import app from 'flarum/forum/app';
import { slug } from '../../common';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import ActivityLeaderItem_Discussions from './ActivityLeaderItem_Discussions';
import HomeActivityLeaderboardState from '../states/HomeActivityLeaderboardState';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home.discussions_leaderboard`;

export default class HomeActivityLeaderboard_Discussions extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		this.state = new this.stateManager(
			this.defaultParams,
			1,
		);
		this.state.refresh();

		// Setting that gives the time-frame of the leaderboard
		this.nDays = '7';//app.forum.attribute(`${slug}.leaderboard_range`);
	}

	get defaultParams() {
		const { params } = this.attrs;
		const defaultParams = { include: [], filter: {}, sort: '-commentCount', page: {'limit': '5'} };
		return {
			...defaultParams,
			...params,
		};
	}

	// for child classes
	getDefaultParams() {
		return this.defaultParams;
	}

	view() {
		return (
			<div className='HomeActivityLeaderboard'>
				<h2 className='title-disc'>
					{this.titleText} {this.loading && <LoadingIndicator />}
				</h2>

				{this.state.isEmpty() && <Placeholder text={this.emptyText} />}

				{this.state.hasItems() && [
					<h3 className='title-sub'>{this.subTitleText}</h3>,
					<ul className='HomeActivityLeaderboard-items'>
						{this.state.getAllItems().map((item, i) => (
							<li
								className='HomeActivityLeaderboard-item'
								key={item.id()}
								data-id={item.id()}>
								{this.listItem(item, i + 1)}
							</li>
						))}
					</ul>,
				]}
			</div>
		);
	}

	listItem(item, position) {
		return <ActivityLeaderItem_Discussions user={item} position={position} />;
	}

	get titleText() {
		return t(`${prfx}.title`);
	}

	get subTitleText() {
		return t(`${prfx}.sub_title`, { days: this.nDays });
	}

	get emptyText() {
		return t(`${prfx}.empty_text`, { days: this.nDays });
	}

	get stateManager() {
		return HomeActivityLeaderboardState;
	}
}
